import { Stack, StackProps, styled } from '@mui/material';

import { generateClasses } from '../../../../../utils/helper';

export const headerClasses = generateClasses('Header', ['title']);

export const Root = styled((props: StackProps) => (
  <Stack direction="row" alignItems="center" gap={2} {...props} />
))(({ theme }) => ({
  [`& .${headerClasses.title}`]: {
    flex: 1,
  },
}));
